/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { V6Route, V6RouteDefinition } from '../../common/types/V6Router';

export const routes: V6RouteDefinition = {
  id: V6Route.MaterialityAssessmentRoot,
  path: 'materiality-assessment',
  children: [
    {
      id: V6Route.MaterialityAssessmentInitiative, path: ':initiativeId', children: [
        {
          id: V6Route.MaterialityAssessmentSurveysList, path: 'surveys', children: [
            {
              id: V6Route.MaterialityAssessmentSurvey, path: ':surveyId', children: [
                {
                  id: V6Route.MaterialityAssessmentSurveyQuestion, path: ':questionId', children: [
                    {
                      id: V6Route.MaterialityAssessmentSurveyQuestionIndex, path: ':questionIndex'
                    }
                  ]
                }
              ]
            },
          ]
        },
        {
          id: V6Route.MaterialityAssessmentTestingTool, path: 'testing-tool'
        }
      ]
    },
  ]
};
